module.exports = __webpack_public_path__ + "static/img/logobackground.0f0a41a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logobackground.png
// module id = xNR3
// module chunks = 16